import React, { useEffect } from "react";
import Card from "components/card";
import BarChartBase from "components/charts/BarChartBase";
import { useDispatch, useSelector } from "react-redux";
import {
  getMonthlyWorkHoursStatistics,
} from "../../../../../redux/overview/overviewState";
import HeaderComponent from "components/card/HeaderComponent";

const MyAttendance = () => {
    const dispatch = useDispatch();

    const data = useSelector((state) => state.overview.monthlyWorkHoursStatistics?.data ?? []);

    useEffect(() => {
        dispatch(getMonthlyWorkHoursStatistics());
    }, [dispatch]);

    return (
        <HeaderComponent
            title="My Attendance"
            description="Monthly work hours over 6 months"
        >
            <BarChartBase 
                data={data}
                xKey="month"
                yKey="hours"
            />
        </HeaderComponent>

    )
};
export default MyAttendance;